import React, {Component, useEffect} from 'react';
import './results.css';
import ResultItem from '../resultItem';
import Button from '../button';
import AnswerItem from "../answerItem";

const Results = props => {
  return (
    <div className="results">
      <h2 className="h2">Результаты</h2>
      {props.resultList.map((value, index) => (
        <ResultItem
          key={index}
          testType={props.testType}
          index={index}
          removeImageResults={props.removeImageResults}
          addImageResults={props.addImageResults}
          activeGroup={props.resultList[index].groupName}
          results={props.results}
          questions={props.questions}
          value={value}
          changeValue={props.changeValue}
          changeResultGroup={props.changeResultGroup}
          changeCommentResult={props.changeCommentResult}
          resultList={props.resultList}
          removeResultItem={props.removeResultItem}
          mailchimpTag={props.mailchimpTag}
          changeResultButtonText={props.changeResultButtonText}
          changeResultButtonLink={props.changeResultButtonLink}
          changeMailchimpTag={props.changeMailchimpTag}
          changeLeadForm={props.changeLeadForm}>
        </ResultItem>
      ))}
      <Button
        textButton="Добавить результат"
        classList="results__btn"
        onClick={props.addResult}
      />
    </div>
  );
};

export default Results;
